import { TaskPriorityUnionType } from '@api';
import {
  faAngleDown,
  faAnglesUp,
  faAngleUp,
  faCircleInfo,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type TaskPriorityPresentationType = {
  icon: FontAwesomeIconProps['icon'];
  labelKey: TaskPriorityUnionType;
  color: string;
};

const PRIORITY_PRESENTATION: Record<
  TaskPriorityUnionType,
  TaskPriorityPresentationType
> = {
  HIGH: {
    icon: faAnglesUp,
    labelKey: 'HIGH',
    color: 'var(--mantine-color-red-6)',
  },
  MEDIUM: {
    icon: faAngleUp,
    labelKey: 'MEDIUM',
    color: 'var(--mantine-color-blue-4)',
  },
  LOW: {
    icon: faAngleDown,
    labelKey: 'LOW',
    color: 'var(--mantine-color-text-5)',
  },
  INFORMATIVE: {
    icon: faCircleInfo,
    labelKey: 'INFORMATIVE',
    color: 'var(--mantine-color-text-5)',
  },
};

export const getTaskPriorityPresentation = (
  priority: TaskPriorityUnionType
): TaskPriorityPresentationType => PRIORITY_PRESENTATION[priority];
